import { Deal } from 'scenes/Dashboard/data/deals/types'

export type SearchFunctionEditFormData = {
  searchFunctionId: string
  fitReason: string
}

export function parseDealToFormData({ searchFunctionId, fitReason }: Deal): SearchFunctionEditFormData {
  return {
    searchFunctionId: searchFunctionId ? String(searchFunctionId) : '',
    fitReason: fitReason ? fitReason : '',
  }
}

export function parseFormDataToDeal({
  searchFunctionId,
  fitReason,
}: SearchFunctionEditFormData): Pick<Deal, 'searchFunctionId' | 'fitReason'> {
  return {
    searchFunctionId: searchFunctionId ? Number(searchFunctionId) : undefined,
    fitReason: fitReason ? fitReason : '',
  }
}
